import { ArrayUtils } from "source/app/services/ArrayUtils";
import IDream from "motw_core/Entity/IDream";
import shuffle from "lodash-es/shuffle";

export function GetRandomDreamData(
    dreams: IDream[]
): [IDream, IDream[]] | undefined {
    const shouldReload = remainingRandomDreams.length === 0;

    if (shouldReload) {
        remainingRandomDreams = shuffle(dreams);
    }

    if (remainingRandomDreams.length > 0) {
        const randomDream = remainingRandomDreams[0];

        remainingRandomDreams = ArrayUtils.ExcludeByPropertyValue(
            remainingRandomDreams,
            "id",
            randomDream.id
        );

        return [randomDream, remainingRandomDreams];
    } else {
        return undefined;
    }
}

let remainingRandomDreams: IDream[] = [];

export function FlushRandomDreamsCache() {
    remainingRandomDreams = [];
}
